import { render, staticRenderFns } from "./PFText.vue?vue&type=template&id=0029ae48&scoped=true&"
import script from "./PFText.vue?vue&type=script&lang=js&"
export * from "./PFText.vue?vue&type=script&lang=js&"
import style0 from "./PFText.vue?vue&type=style&index=0&id=0029ae48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029ae48",
  null
  
)

export default component.exports